import { Survey } from 'app/graphql/__generated__/types/contento';
import { ButtonTheme, ButtonType } from 'app/ui-components/PlayButton/PlayButton';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import React from 'react';
import { Task as TaskModel } from '../models';
import { Button, Byline, Heading, TaskButtonWrapper } from '../UsabilityTest.styles';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    task: TaskModel;
    onCloseSurvey: (value: string) => void;
    survey: Survey;
};

const Task = ({ onClick, task, onCloseSurvey, survey }: Props) => (
    <>
        <Byline size={SIZE.SMALL}>Uppgift</Byline>

        <Heading>{task.heading}</Heading>

        <TaskButtonWrapper>
            <Button
                buttonType={ButtonType.BUTTON}
                theme={ButtonTheme.DEFAULT}
                type="button"
                onClick={() => {
                    onCloseSurvey(survey.id);
                }}
                cancel
            >
                Avbryt
            </Button>
            <Button buttonType={ButtonType.BUTTON} onClick={onClick} theme={ButtonTheme.WHITE}>
                Jag är klar med uppgiften
            </Button>
        </TaskButtonWrapper>
    </>
);

export default Task;
